import { render, staticRenderFns } from "./TaskActivity.vue?vue&type=template&id=2a063a0c&scoped=true&"
import script from "./TaskActivity.vue?vue&type=script&lang=js&"
export * from "./TaskActivity.vue?vue&type=script&lang=js&"
import style0 from "./TaskActivity.vue?vue&type=style&index=0&id=2a063a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a063a0c",
  null
  
)

export default component.exports